import { action } from "mobx";
import { GiftCertificateDto, SalesApi, SalesTimeSlotDto } from "../../api-client";
import AuthStore from "../Auth/authStore";
import notificationStore from "../Notification/notificationStore";

export default class SalesStore {
  public apiClient: SalesApi;
  public authStore: AuthStore;

  public constructor(apiClient: SalesApi, authStore: AuthStore) {
    this.apiClient = apiClient;
    this.authStore = authStore;
  }

  public getSaleServices = async () => {
    const { data } = (await this.apiClient.getSaleServices()) as any;
    return data || [];
  };

  public getUnpaidGiftCertificates = async () => {
    const { data } = (await this.apiClient.getUnpaidGiftCertificates()) as any;
    return data || [];
  };

  public getGiftCertificateById = async (code: string) => {
    try {
      const { data } = (await this.apiClient.getGiftCertificateById(code)) as any;
      return data || [];
    } catch (error: any) {
      console.error("Error fetching user:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.message ||
        "Fehler beim Abrufen des Geschenkgutscheins";

      notificationStore.showMessage(errorMessage, "error", error);
      return null;
    }
  };

  public getGiftCertificatesByPatientId = async (patientId: number) => {
    try {
      const { data } = (await this.apiClient.getGiftCertificatesByPatientId(patientId)) as any;
      return data || [];
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.message ||
        "Geschenkgutscheine für Patienten konnten nicht abgerufen werden";

      notificationStore.showMessage(errorMessage, "error", error);
      return null;
    }
  };

  public updateGiftCard = async (patientId: number, code: string) => {
    try {
      const { data } = (await this.apiClient.updateGiftCard(patientId, code)) as any;
      return data || [];
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.message ||
        "Fehler beim Aktualisieren der Geschenkkarte";

      notificationStore.showMessage(errorMessage, "error", error);
      return null;
    }
  };

  public getServicesByPatient = async (id: number): Promise<SalesTimeSlotDto[]> => {
    try {
      const { data } = (await this.apiClient.getServicesByPatient(id)) as any;

      return data || [];
    } catch (error) {
      console.error("Error fetching unpaid services:", error);
      notificationStore.showMessage(
        `Error fetching unpaid bills for patient ID ${id}:`,
        "error",
        error
      );
      throw error;
    }
  };

  public deleteGiftCertificate = async (id: string) => {
    try {
      await this.apiClient.deleteGiftCertificate(id);
      notificationStore.showMessage("Gutschein wurde gelöscht", "success");
      return true;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.message ||
        "Gutschein konnte nicht gelöscht werden";

      notificationStore.showMessage(errorMessage, "error", error);
      return false;
    }
  };

  public createGiftCertificate = async (gcDto: GiftCertificateDto) => {
    try {
      const { data } = (await this.apiClient.createGiftCertificate(gcDto)) as any;
      notificationStore.showMessage("Geschenkgutschein erfolgreich erstellt", "success");
      return data || [];
    } catch (error: any) {
      console.error("Error fetching user:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.message ||
        "Geschenkgutschein konnte nicht erstellt werden!!";

      notificationStore.showMessage(errorMessage, "error", error);
      return null;
    }
  };
}
